export enum OperatingSystemType {
  Windows = 'win',
  Mac = 'mac',
  Linux = 'linux',
  Android = 'android',
  IOs = 'ios',
}
